// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const TwitterX = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M86.4328571,14.9828571 L78.8485714,4.95142857 L77.5842857,4.95142857 L85.2542857,14.9828571 L86.4285714,14.9828571 L86.4328571,14.9828571 Z M88.12,3.75 L83.4857143,9.04571429 L88.9371429,16.25 L84.67,16.25 L81.33,11.88 L77.5042857,16.25 L75.3842857,16.25 L80.3385714,10.5857143 L75.1114286,3.75 L79.4871429,3.75 L82.5085714,7.74571429 L86,3.75 L88.12,3.75 Z M74.8571429,0 C73.2814286,0 72,1.28142857 72,2.85714286 L72,17.1428571 C72,18.72 73.2814286,20 74.8571429,20 L89.1428571,20 C90.7185714,20 92,18.72 92,17.1428571 L92,2.85714286 C92,1.28142857 90.7185714,0 89.1428571,0 L74.8571429,0 Z"
                transform="translate(-72)"
            />
        </svg>
    );
};

export default React.memo(TwitterX);
